import { BookingFormMode } from "PFApp/booking/components/booking_form/booking_form.types";
import { OnSuccessData } from "PFApp/booking/components/booking_form/use_handle_submit/use_handle_submit";
import { DetailsPanelSource, useDetailsPanelsActions } from "PFApp/booking/components/details_panel";
import ButtonGroup from "PFComponents/button_group/button_group";
import { DropdownOption } from "PFComponents/dropdown";
import { DropdownButton } from "PFComponents/dropdown_button";
import { useTranslation } from "react-i18next";

import { useBookingDetailSidePanelContext } from "../booking_detail_side_panel_context";
import css from "./edit_button.module.scss";
import { EditSingleButton } from "./edit_single_button";

type EditButtonProps = {
  bookingId: number;
  isRepeatedBooking: boolean;
  onSuccess: (data: OnSuccessData) => void;
  source?: DetailsPanelSource;
  disabled?: boolean;
};

export const EditButton = ({
  bookingId,
  isRepeatedBooking,
  onSuccess,
  source,
  disabled
}: EditButtonProps) => {
  const { t } = useTranslation("bookingModule");
  const { profile, siblingBookings } = useBookingDetailSidePanelContext();
  const { openBookingFormSidePanel } = useDetailsPanelsActions();

  const handleEdit = (mode: BookingFormMode) => {
    const isSuspended = !!profile?.suspendedAt;
    openBookingFormSidePanel(
      { bookingId, ...(isSuspended ? { suspendedProfileDetails: profile } : {}) },
      { onSuccess, mode, source }
    );
  };

  if (isRepeatedBooking) {
    return <EditSingleButton onClick={() => handleEdit(BookingFormMode.EditAll)} disabled={disabled} />;
  }

  const isEditAllAvailable = (siblingBookings?.length ?? 0) > 1;

  if (!isEditAllAvailable) {
    return <EditSingleButton onClick={() => handleEdit(BookingFormMode.EditSingle)} disabled={disabled} />;
  }

  const options: DropdownOption[] = [
    {
      id: BookingFormMode.EditAll,
      displayElement: t("bookings.update.editMultipleBookings"),
      item: BookingFormMode.EditAll
    }
  ];

  return (
    <ButtonGroup compact autoWidth>
      <EditSingleButton onClick={() => handleEdit(BookingFormMode.EditSingle)} disabled={disabled} />
      <DropdownButton
        buttonClassName={css.dropdownButton}
        icon="chevron-down"
        options={options}
        handleChange={(item) => handleEdit(item)}
        floatingOptions={{ placement: "bottom-end" }}
        buttonKind="secondary"
        disabled={disabled}
      />
    </ButtonGroup>
  );
};
